import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=55a37cd4&scoped=true&"
import script from "./goods.vue?vue&type=script&lang=js&"
export * from "./goods.vue?vue&type=script&lang=js&"
import style0 from "./goods.vue?vue&type=style&index=0&id=55a37cd4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a37cd4",
  null
  
)

export default component.exports